import { render, staticRenderFns } from "./Artist.vue?vue&type=template&id=4d605f41&"
import script from "./Artist.vue?vue&type=script&lang=js&"
export * from "./Artist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports